import { render, staticRenderFns } from "./PagosPedidoModal.vue?vue&type=template&id=b3c969bc&scoped=true&"
import script from "./PagosPedidoModal.vue?vue&type=script&lang=js&"
export * from "./PagosPedidoModal.vue?vue&type=script&lang=js&"
import style0 from "./PagosPedidoModal.vue?vue&type=style&index=0&id=b3c969bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c969bc",
  null
  
)

export default component.exports